/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.2
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {type AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig} from "./helper";
import type PaginationResponse from "./PaginationResponse";
import type ApiInterceptorRow from "./ApiInterceptorRow";
import type PaginationRequestSearch from "./PaginationRequestSearch";
import type ApiInterceptor from "./ApiInterceptor";

const urls = {
    detail(id: number): string {
        return queryUrl("/api/apiinterceptor/detail", {id});
    }
}

export default {
    urls,
    paged(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<ApiInterceptorRow>>> {
        return Axios.post("/api/apiinterceptor/paged", request, defaultConfig);
    },
    detail(id: number): Promise<AxiosResponse<ApiInterceptor>> {
        return Axios.get(queryUrl("/api/apiinterceptor/detail", {id}), defaultConfig);
    }
}
